/**
 * Created by mateimisarca on 24/09/2020
 */

import DataTable from './data-table';

export default DataTable;
